import { apiPixl } from '@spo/services/api';
import { PostApiPixlModelsImagesBody } from '@spo/types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export interface ModelImage {
  code: string;
  imageURL: string;
}

export const usePixlImages = ({
  modelCodes,
  width,
  height,
  contentMediaUrl,
}: PostApiPixlModelsImagesBody) => {
  return useQuery({
    queryKey: ['usePixlImages', modelCodes, width, height],
    queryFn: async () => {
      const response = await apiPixl.getModelsImages({
        modelCodes,
        width,
        height,
        contentMediaUrl,
      });
      return response;
    },
    placeholderData: keepPreviousData,
    enabled: modelCodes.length > 0,
  });
};
